
import { defineComponent } from "vue";
import { yReactive } from "@/util";
import { todos as _todos, makeTodo as _makeTodo } from "@/store/todo";
import Todo from "./Todo.vue";

export default defineComponent({
  name: "TodoList",
  components: { Todo },
  props: {},
  setup() {
    const todos = yReactive(_todos);

    function makeTodo(e: KeyboardEvent) {
      const target = e.target as HTMLInputElement;
      _makeTodo({ text: target.value });
      target.value = "";
    }

    return { todos, makeTodo };
  },
});
